import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { motion } from "framer-motion";
import type { BoardCardProps } from "./types";

const TRANSITION_DURATION = 200;
const TRANSITION_EASING = "ease";

export function BoardCard({ id, children }: BoardCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    transition: {
      duration: TRANSITION_DURATION,
      easing: TRANSITION_EASING,
    },
  });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition:
      transition ?? `transform ${TRANSITION_DURATION}ms ${TRANSITION_EASING}`,
    opacity: isDragging ? 0.4 : 1,
    position: "relative" as const,
    zIndex: isDragging ? 0 : "auto",
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {children}
      {isDragging && (
        <motion.div
          className="absolute inset-0 rounded-xl bg-accent/5 border-2 border-dashed border-accent/20"
          animate={{ opacity: [0.3, 0.6, 0.3] }}
          transition={{
            duration: 1.5,
            repeat: Number.POSITIVE_INFINITY,
            ease: "easeInOut",
          }}
        />
      )}
    </div>
  );
}
